<template>
  <!-- <div v-if="(premium || chosenLimit) && process === 'NORMAL'" class="alert alert-dark mb-5"> -->
  <div v-if="premium || chosenLimit" class="alert alert-dark mb-5">
    <h1 class="h2 text-white">
      AZ ÖN ÁLTAL MEGADOTT ADATOK ALAPJÁN A BIZTOSÍTÁSI DÍJ:
    </h1>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold">Díj</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" disabled :value="premium | currency" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold">Választott limit:</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" disabled :value="limittomb[chosenLimit].name" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold">Process:</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" disabled v-model="process" />
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';
import RequestPdfButon from './RequestPdfButton.vue';
import SaveLinkButton from './SaveLinkButton.vue';

export default {
  components: {RequestPdfButon, SaveLinkButton},
  computed: {
    ...mapFields([
      'currency',
      'insuranceYearlyPrice',
      'eves_dij',
      'premium',
      'chosenLimit',
      'double_limit',
      'limittomb',
      'process',
    ]),
    IsDoubleLimit: function() {
      if (this.double_limit === 'double_limit') return 'Igen';
      else return 'Nem';
    },
  },
};
</script>
